import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      resultDataKey: "customerInvestRecordVOS"
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_cell, {
        title: item.productName
      }, {
        label: _withCtx(() => [item.productSubType === '02' ? (_openBlock(), _createBlock(_component_van_row, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("投资金额： " + _toDisplayString(item.actualSubscriptionAmount + '元'), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("产品期限： " + _toDisplayString(item.productDuration), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("到期日期： " + _toDisplayString(item.expireDate), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("到期状态： " + _toDisplayString(item.tradeDueState), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_van_row, {
          key: 1,
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "24"
          }, {
            default: _withCtx(() => [_createTextVNode("投资金额： " + _toDisplayString(item.actualSubscriptionAmount + '元'), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("存续份额: " + _toDisplayString(item.leftShare), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("存续金额：" + _toDisplayString((item.leftShare * item.netValue).toFixed(2)), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("最新净值：" + _toDisplayString(item.netValue), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("净值日期：" + _toDisplayString(item.publicDate), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024))]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter"])]),
    _: 1
  });
}